import { render, staticRenderFns } from "./join-records.vue?vue&type=template&id=2a0b6dac"
import script from "./join-records.vue?vue&type=script&lang=js"
export * from "./join-records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports